import { Header } from "../../components/Header/Header";
import s from "./style.module.scss";
import { useAction, useAtom } from "@reatom/npm-react";
import { useEffect, useMemo, useState } from "react";
import { Epic } from "../../components/Epic/Epic";
import { Card } from "../../components/Card/Card";
import clsx from "clsx";
import {
  getCurrentOrderAction,
  getOrdersAction,
  ordersAtom,
} from "@/core/reatom/state/orders/orders";
import { isCardViewAtom } from "@/core/reatom/state/CardView";
import { useNavigate } from "react-router";
import { Block } from "@/components/Block/Block";
import { FlexWrapper } from "@/components/FlexWrapper/FlexWrapper";
import { CardViewSwithcer } from "@/components/CardViewSwithcer/CardViewSwithcer";
import { ProcessStatus } from "@/core/reatom/state/orders/types";
import { activeOrderFilter } from "@/core/reatom/state/OrderFilter";

export const OrdersPage = () => {
  const handleOrders = useAction(getOrdersAction);
  useEffect(() => {
    handleOrders();
  }, []);
  const [activeButton, setActiveButton] = useAtom(activeOrderFilter);
  const [orders] = useAtom(ordersAtom);

  // "completed" | "new" | "declined" | "cancelled" | "not_answered" | "accepted" | "work_finished" | "fix"
  const filterOrder = (status: ProcessStatus) =>
    status === "new" ||
    status === "accepted" ||
    status === "fix" ||
    status === "work_finished";
  const completed = useMemo(() => {
    return orders?.items.filter((order) => !filterOrder(order.process_status));
  }, [orders?.items]);

  const current = useMemo(() => {
    return orders?.items.filter((order) => filterOrder(order.process_status));
  }, [orders?.items]);

  const [isCardView] = useAtom(isCardViewAtom);
  const navigate = useNavigate();
  const handleCurrentOrder = useAction(getCurrentOrderAction);
  const [scrollPosition, setScrollPosition] = useState(0);

  return (
    <>
      <FlexWrapper className={s.flexWrapper}>
        <div className={s.header}>
          <Header title="Заказы" />
          <div className={s.buttons}>
            <button
              className={clsx(
                s.button,
                s.left,
                activeButton === "current" && s.active
              )}
              onClick={() => setActiveButton("current")}
            >
              Текущие
              {!!current && (
                <p
                  className={clsx(
                    s.count,
                    activeButton === "current" && s.activeCount
                  )}
                >
                  {current.length ?? 0}
                </p>
              )}
            </button>
            <button
              className={clsx(
                s.button,
                s.right,
                activeButton === "completed" && s.active
              )}
              onClick={() => setActiveButton("completed")}
            >
              Закрытые
              {!!completed && (
                <p
                  className={clsx(
                    s.count,
                    activeButton === "completed" && s.activeCount
                  )}
                >
                  {completed.length ?? 0}
                </p>
              )}
            </button>
          </div>
        </div>
        <Block
          borderRadius="top"
          className={s.block}
          wihoutPadding={isCardView}
          onScroll={(e) => setScrollPosition(e.currentTarget.scrollTop)}
        >
          <div>
            <div
              className={clsx(s.gridContainer, {
                [s.cardGrid]: !isCardView,
                [s.listGrid]: isCardView,
              })}
            >
              {activeButton === "current" &&
                current &&
                current?.map((order) => (
                  <Card
                    src={
                      order?.preview_files?.[0]?.url ??
                      order.freelancers[0]?.photo_url
                    }
                    price={`${order.reserve_price.toLocaleString("ru-RU")} ₽`}
                    description={order.title}
                    id={order.id}
                    waitingTime={order.ends_in.duration}
                    className={s.card}
                    onClick={() => {
                      handleCurrentOrder({ orderId: order.id });
                      navigate(`/checkout/${order.id}`);
                    }}
                  />
                ))}
              {activeButton === "completed" &&
                completed &&
                completed?.map((order) => (
                  <Card
                    src={
                      order?.preview_files?.[0]?.url ??
                      order.freelancers[0]?.photo_url
                    }
                    price={`${order.reserve_price.toLocaleString("ru-RU")} ₽`}
                    description={order.title}
                    id={order.id}
                    waitingTime={order.ends_in.duration}
                    className={s.card}
                    onClick={() => {
                      handleCurrentOrder({ orderId: order.id });
                      navigate(`/checkout/${order.id}`);
                    }}
                  />
                ))}
            </div>
          </div>
        </Block>
      </FlexWrapper>{" "}
      {orders && orders.items.length && (
        <CardViewSwithcer scrollY={scrollPosition} />
      )}
      <Epic />
    </>
  );
};
